import React from "react";
import apiRequest from "../../../utils/towerHeadAdmin/apiRequest";
import Button from "../../ui/utils/Button";
import Alert from "../../ui/utils/Alert";
import usePost from "../../../hooks/api/usePost";

const DeleteGallery = ({ closeModal, callback, data }) => {
  const { error, isLoading, post } = usePost(apiRequest.deleteGallery);

  const handleDelete = async () => {
    const response = await post({ data: { id: data?._id } });
    if (response?.response) {
      callback();
      closeModal();
    }
  };

  return (
    <div className="p-4 text-sm">
      {error && <Alert message={error} type="error" />}

      <p className="mb-4">
        Are you sure you want to delete this media?
        <br />
        <strong>{data?.name || "Unnamed File"}</strong>
      </p>

      <div className="flex justify-end gap-2">
        <Button variant="secondary" onClick={closeModal}>
          Cancel
        </Button>
        <Button
          variant="danger"
          isLoading={isLoading}
          loadingText="Deleting..."
          onClick={handleDelete}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default DeleteGallery;
